import React from 'react';
import PropTypes from 'prop-types';
import MemberStore from '../../stores/MemberStore';
import cx from '../../utils/cx.js';
import ImageSvg from '../images/ImageSvg.react';
import get from 'lodash/get';

const ReactPropTypes = PropTypes;

function removeExtension(filename) {
  return filename.substr(0, filename.lastIndexOf('.')) || filename;
}

function getStateFromStores(memberId) {
  return {
    member: MemberStore.get(memberId),
    myId: MemberStore.getMyID(),
  };
}

class MemberImage extends React.Component {
  static propTypes = {
    memberId: ReactPropTypes.string,
    type: ReactPropTypes.string,
  };

  static defaultProps = {
    memberId: null,
    type: 's',
    top_nr: null,
    vipOn: false,
  };

  state = getStateFromStores(this.props.memberId);

  componentDidMount() {
    MemberStore.addChangeMemberListener(this._onChange);
  }

  componentWillUnmount() {
    MemberStore.removeChangeMemberListener(this._onChange);
  }

  render() {
    let memberImageUrl = '';
    let isOnline = false;
    let isHighlighted = false;
    let vipIcon = false;
    let member = null;
    let status = 'deleted';
    const top_nr = this.props.top_nr;

    if (this.state.member) {
      member = this.state.member;
      status = member.status;
    }

    if (this.props.vipOn) {
      memberImageUrl = `${get(globals, 'staticImageUri', '')}profile/blank-vip.png`;
    }
    // deleted vai admin
    else if (status == 'deleted' || status == 'admin') {
      memberImageUrl = `${get(globals, 'staticImageUri', '')}profile/${status}.png`;
    }
    // active lietotājs
    else {
      let sex = member.sex;
      if (sex) {
        sex = sex.toLowerCase();
      }

      if (member.image) {
        let imageType = this.props.type;
        if (imageType == 'xs') {
          imageType = 's';
        }
        // TODO Diezgan apšaubāmi, bet pagaidām.. gcloud bildēm tagad ir īsāks nosaukums..
        if (member.image.split('').length < 30) {
          memberImageUrl = `${globals.gcloudUri}${imageType}/${member.image}`;
        } else {
          memberImageUrl = `${globals.imagesBaseUri}images/get/${imageType}/${removeExtension(member.image)}/${sex}`;
        }
      } else {
        let filename = 'blank';
        if (sex) {
          filename += `-${sex}`;
        }
        memberImageUrl = `${get(globals, 'staticImageUri', '')}profile/${filename}.png`;
      }

      // savam profilam neliek online pazīmi
      if (member.online && member._id != this.state.myId) {
        isOnline = true;
      }

      if (this.props.vipIcon) {
        vipIcon = true;
      }

      // savam profilam neliek highlighted pazīmi
      if (member.highlighted && member._id != this.state.myId) {
        isHighlighted = true;
      }
    }

    const memberImageNumber = function () {
      if (top_nr == null) {
        return ('');
      }

      return (<span className="memberImage-number">{top_nr}</span>);
    };

    const memberIcons = function () {
      const icons = [];

      if (member.favorite) {
        icons.push(
          <span key="favorite" className="memberImage-icon">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg svg="icon-heart-2" iconClass="icon icon--heart-2" />
              </span>
            </span>
          </span>);
      }

      if (member.was_visited_by_me) {
        icons.push([
          <span key="was_visited_by_me" className="memberImage-icon">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg svg="icon-watched-2" iconClass="icon icon--watched-2" />
              </span>
            </span>
          </span>,
        ]);
      }

      if (member.was_messaged_by_me) {
        icons.push(
          <span key="was_messaged_by_me" className="memberImage-icon">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg svg="icon-mail" iconClass="icon icon--mail" />
              </span>
            </span>
          </span>);
      }

      if (icons.length < 1) {
        return ('');
      }

      return (
        <div className="memberImage-iconContainer">
          {icons}
        </div>
      );
    };

    return (
      <div
        className={cx([
          'memberImage',
          `memberImage--${this.props.type}`,
          ['is-online', isOnline],
          ['is-highlighted', isHighlighted],
        ])}
      >
        <img className="memberImage-item" src={memberImageUrl} />
        {memberIcons()}
        {memberImageNumber()}
      </div>
    );
  }

  /**
  * Event handler for 'change' events coming from the stores
  */
  _onChange = () => {
    this.setState(getStateFromStores(this.props.memberId));
  };
}

module.exports = MemberImage;
